import api from "./api";

export const inventoryService = {
  // Assets
  getAllAssets: (params) => api.get("/inventory/assets", { params }),

  getAssetById: (id) => api.get(`/inventory/assets/${id}`),

  createAsset: (assetData) => api.post("/inventory/assets", assetData),

  updateAsset: (id, assetData) => api.put(`/inventory/assets/${id}`, assetData),

  deleteAsset: (id) => api.delete(`/inventory/assets/${id}`),
};
